module.exports = {"notification.message":"Wix.com使用Cookie以提供最佳訪問體驗。","notification.got.it":"知道了","notification.more.info":"閲讀更多","notification.got.it.arrow":"arrow icon"}


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_zh.json
// module id = 61
// module chunks = 0